<template>
  <div class="agency-swiper-wrap">
    <div class="main-width">
      <div class="agency-swiper-container swiper-container-outer">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="(item, index) in list" :key="index">
            <HomeAgency :data="item"></HomeAgency>
          </swiper-slide>
        </swiper>
        <!-- 分页 -->
        <div class="swiper-pagination my-swiper-pagination swp-page2"></div>
        <!-- 左按钮 -->
        <div class="swiper-button-prev my-swiper-button swp2"></div>
        <!-- 右按钮 -->
        <div class="swiper-button-next my-swiper-button swp2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import SwiperCore, { Navigation, Pagination } from "swiper";
// Import Swiper styles
import "swiper/swiper.less";
import "swiper/components/navigation/navigation.less";
import "swiper/components/pagination/pagination.less";
// install Swiper modules
SwiperCore.use([Navigation, Pagination]);
import HomeAgency from "./homeAgency";

const swiperDelay = 5000; // 切换swiper 

export default {
  data() {
    return {
      list: [{
        video: "/cms/static/brief.MP4",
        poster: "/cms/static/brief_poster.png",
        detailUrl: "/views/agency/brief",
        title: "机构概况",
        summary: "在党的二十大胜利召开的新起点上，习近平总书记的重要报告为学界构建中国话语和中国叙事体系指明了方向、提供了理据。为了加快构建中国话语和叙事体系，在全球格局与历史视野中重新认识中国话语与世界的内外关联和文明互鉴，推进交叉学科学术研究、人才培养与国际传..."
      },
      {
        video: "/cms/static/2024video.mp4",
        poster: "/cms/static/2024video_poster.png",
        detailUrl: "/views/agency/workReport/2024",
        title: "中国话语与世界文学研究中心2024年度回顾",
        summary: "中国话语与世界文学研究中心是上海外国语大学校级实体科研机构，以特色化、高端化、国际化为发展定位。2024年，在校党委及各级领导的关怀指导、上海全球治理与区域国别研究院的支持下，研究中心在学术创新、成果转化、人文交流、人才培养与话语传播等方面协同发展，积极助力我校构建融通中外的学术话语体系。"
      },
      {
        video: "/cms/static/A.mp4",
        poster: "/cms/static/A_poster.png",
        detailUrl: "/views/agency/workReport/2023",
        title: "中国话语与世界文学研究中心2023年度工作报告",
        summary: "作为上海外国语大学2022年底设立的多语种、跨学科、实体化运作学术研究机构，中国话语与世界文学研究中心以特色化、高端化、国际化为发展定位，以培育、申报、完成国家级与省部级重大前沿课题、孵化标志性成果为导向，致力构建融通中外的话语体系。在上海外国语大学校党委和各级领导的关怀指导、上海全球治理与区域国别研究院的鼎力支持下，研究中心2023年在学术创新、成果转化、人文交流、学科建设、人才培养与话语传播等方面协同发展，积极助力我校外语学科发展。"
      }, 
     
      {
        video: "/cms/static/B.mp4",
        poster: "/cms/static/B_poster.png",
        detailUrl: "https://cdwl.shisu.edu.cn/cms/#/views/lastNewsDetails/0de00372-96a1-40d7-858b-59e23f6ba0c3",
        title: "中国话语与世界文学研究丛书发布",
        summary: "2024年1月12日，由上海外国语大学中国话语与世界文学研究中心、上海全球治理与区域国别研究院主办的“上海国别区域全球知识文库·中国话语与世界文学研究丛书”新书发布会顺利召开。学术界与出版界众多资深专家线上线下共聚新书发布会，围绕中国话语、世界文学与国别区域研究等议题展开深入交流。新书发布会由中国话语与世界文学研究中心主任张帆教授主持；上海全球治理与区域国别研究院理事长、学术委员会主任姜锋教授，上海外国语大学党委常委、副校长查明建教授，商务印书馆上海分馆总经理、总编辑鲍静静女士，以及上海全球治理与区域国别研究院执行院长杨成教授共同为新书揭幕。中国话语与世界文学研究中心学术委员会全体成员、新书作者代表等嘉宾列席发布会。"
      }, {
        video: "/cms/static/C.mp4",
        poster: "/cms/static/C_poster.png",
        detailUrl: "/views/homeDetails/cb702e58-212b-4b93-98e2-351c7c82f08f",
        title: "上海文学海外译介传播研究（德语译介卷）",
        summary: "《上海文学海外译介传播研究（德语译介卷）》作为“中国文学海外译介研究丛书”的重要成果，入选上海市重点图书，获上海文化发展基金、上海全球治理与区域国别研究院资助，中国话语与世界文学研究中心出品；由上海外国语大学孙国亮教授等著，上海大学出版社江振新编审、徐雁华编辑精心编校，2022年出版，2024年第二次印刷。"
      }, {
        video: "/cms/static/germanSinology.mp4",
        poster: "/cms/static/germanSinology_poster.png",
        detailUrl: "/views/sudiDetails/d32a55e5-7ddc-4cce-9e79-2f6c247cc03f",
        title: "张帆主编：《德国汉学期刊文献辑录与研究》",
        summary: "《德国汉学期刊文献辑录与研究》作为“中国文学海外译介研究丛书”之一，由上海外国语大学张帆教授主编，中国话语与世界文学研究中心出品，上海全球治理与区域国别研究院资助，上海大学出版社2024年11月出版。"
      }],

      
      swiperOptions: {
        loop: true,
        autoplay: false,
        slidesPerView: "auto", //显示个数
        touchStartPreventDefault: false, // 不阻止事件
        observer: true,
        observerParents: true,
        pagination: {
          el: ".swiper-pagination.swp-page2",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next.swp2",
          prevEl: ".swiper-button-prev.swp2",
        },
      },
      mobileWidth: false
    }
  },
  props: {
    
  },
  components: {
    HomeAgency
  },
  mounted() {
    this.setVisibleNumber();
  },
  methods: {
    setVisibleNumber() {
      const width = document.body.getBoundingClientRect().width;
      this.mobileWidth = parseInt(width) <= 768;
    },
  },
  beforeMount() {
    window.addEventListener('resize', this.setVisibleNumber)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setVisibleNumber)
  },
}
</script>

<style lang="less" scoped>
.agency-swiper-wrap {
  background: #f1f4fb;
  padding: 40px 0;
}
.swiper-container-outer {
  width: 100%;
  height: 100%;
  box-shadow: 0px 0px 4px 4px rgba(0, 0, 0, 0.12);
  position: relative;
  .slide-content {
    width: 100%;
    height: 100%;
    position: relative;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    .el-image {
      width: 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .my-swiper-pagination {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    /deep/ .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      border-radius: 100%;
      margin: 0 6px;
      background: #fff;
    }
  }
  .my-swiper-button {
    // width: 30px;
    background: transparent;
    color: #aacae1;
    border-radius: 2px;
    &.swiper-button-prev {
      left: -40px;
    }
    &.swiper-button-next {
      right: -40px;
    }
    &::after {
      font-size: 42px;
      font-weight: bold;
    }
  }
  .swiper-container {
    width: 100%;
    height: 100%;
    .swiper-slide {
      color: #fff;
      > div {
        height: 100%;
      }
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1280px) {
  .agency-swiper-wrap {
    padding-bottom: 44%;
  }
}

@media screen and (max-width: 768px) {
  .agency-swiper-wrap {
    padding-bottom: 60%;
  }

  .swiper-container-outer {
    .my-swiper-pagination {
      bottom: 14px;
      /deep/ .swiper-pagination-bullet {
        width: 6px;
        height: 6px;
        border-radius: 100%;
      }
    }
    .my-swiper-button {
      &.swiper-button-prev {
        left: 14px;
      }
      &.swiper-button-next {
        right: 14px;
      }
      &::after {
        font-size: 22px;
      }
    }
    .swiper-container {
      width: 100%;
      height: 100%;
      .swiper-slide {
        color: #fff;
        > div {
          height: 100%;
        }
      }
    }
  }
}
</style>